 import React from 'react';

import { Admin, Resource } from 'admin-on-rest';
import marketRestClient from './restClient';
import authClient from './authClient';
import UserIcon from 'material-ui/svg-icons/social/group';
import OrderIcon from 'material-ui/svg-icons/action/done';
var Config = require('./config')

import { ProductsList, CreateProduct, EditProduct, DeleteProduct } from './pages/products';
import { OrdersList, CreateOrders, EditOrders, DeleteOrders, showOrders } from './pages/orders';
import { UserList, CreateUser, EditUser, DeleteUser} from './pages/users';
import { TurnoverList} from './pages/turnover';
import Dashboard from './custom/Dashboard';
const App = () => (
    <Admin
      authClient={authClient}
      dashboard={Dashboard}
      restClient={marketRestClient(Config.serverUrl+"api")}
      title="Gountsidis Admin Panel">

      <Resource
        name="order"
        list={OrdersList}
        create={CreateOrders}
        show={showOrders}
        edit={EditOrders}
        remove={DeleteOrders}
        icon={OrderIcon}
      />
      <Resource
      name="product"
      list={ProductsList}
      create={CreateProduct}
      edit={EditProduct}
      remove={DeleteProduct}
      />

      <Resource
      name="users"
      list={UserList}
      create={CreateUser}
      edit={EditUser}
      remove={DeleteUser}
      icon={UserIcon}
      />

      <Resource
      label="Orders Profit"
      name="turnovers"
      list={TurnoverList}
      icon={OrderIcon}
      />

    </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js